import React from "react"
import { Formik } from "formik"
import Yup from "yup"
import { createRequest } from "utils/request-helper"
import {
  months,
  days,
  years,
  types,
  states,
  genders,
} from "utils/camp-parameters"
import FormWrapper from "components/Form/FormFields/FormWrapper"
import SectionHeader from "components/Form/FormFields/SectionHeader"
import ErrorMessage from "components/Form/FormFields/ErrorMessage"
import TextInput from "components/Form/FormFields/TextInput"
import InlineInputWrapper from "components/Form/FormFields/InlineInputWrapper"
import DateSelect from "components/Form/FormFields/DateSelect"
import InlineInput from "components/Form/FormFields/InlineInput"
import SubmitButton from "components/Form/FormFields/SubmitButton"
import glamorous from "glamorous"
import style from "utils/style"

export class CampNewForm extends React.Component {
  state = {
    camp_specialties: [],
    camp_expertises: [],
  }

  componentWillMount() {
    createRequest(
      { method: "GET", route: "camp_specialties" },
      response => this.setState({ camp_specialties: response.data.data }),
      error => {
        this.setState({ camp_specialties: null })
      }
    )

    createRequest(
      { method: "GET", route: "camp_expertises" },
      response => this.setState({ camp_expertises: response.data.data }),
      error => {
        this.setState({ camp_expertises: null })
      }
    )
  }

  componentWillReceiveProps(newProps) {
    if (this.props.isSubmitting && newProps.hasErrors) {
      this.props.setSubmitting(false)
    }
  }

  pushToValue(event, valueIndex, value) {
    event.persist()

    if (event.target.checked && !valueIndex.includes(value)) {
      valueIndex.push(value)
    } else if (!event.target.checked && valueIndex.includes(value)) {
      valueIndex.splice(valueIndex.indexOf(value), 1)
    }
  }

  render() {
    const {
      values,
      touched,
      errors,
      isSubmitting,
      handleChange,
      handleBlur,
      handleSubmit,
      formError,
    } = this.props

    return (
      <Container>
        <FormTitle>New Camp</FormTitle>

        {formError && (
          <ErrorMessage>
            Could not create camp. Please try again. {formError}.
          </ErrorMessage>
        )}

        <FormWrapper onSubmit={handleSubmit}>
          <FormContainer>
            <InputFields>
              <Section>
                <SectionHeader title="Camp Information" />
                <TextInput
                  id="name"
                  label="Name"
                  placeholder="Enter the camp name"
                  type="text"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.name && errors.name}
                  inline
                />
                <TextInput
                  id="email"
                  label="Email"
                  placeholder="Enter contact email"
                  type="text"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.email && errors.email}
                  inline
                />
                <DateSelect
                  id="session_start_date"
                  label="Session Start"
                  values={values}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  months={months}
                  days={days}
                  years={years}
                />
                <DateSelect
                  id="session_end_date"
                  label="Session End"
                  values={values}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  months={months}
                  days={days}
                  years={years}
                />
                <TextInput
                  id="website"
                  label="Website"
                  placeholder="Enter website URL"
                  type="text"
                  value={values.website}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.website && errors.website}
                  inline
                />
                <TextInput
                  id="facebook"
                  label="Facebook"
                  placeholder="Enter Facebook URL"
                  type="text"
                  value={values.facebook}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.facebook && errors.facebook}
                  inline
                />
                <TextInput
                  id="twitter"
                  label="Twitter"
                  placeholder="Enter Twitter URL"
                  type="text"
                  value={values.twitter}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.twitter && errors.twitter}
                  inline
                />
                <TextInput
                  id="skype"
                  label="Skype"
                  placeholder="Enter Skype URL"
                  type="text"
                  value={values.skype}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.skype && errors.skype}
                  inline
                />
                <TextInput
                  id="instagram"
                  label="Instagram"
                  placeholder="Enter Instagram URL"
                  type="text"
                  value={values.instagram}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.instagram && errors.instagram}
                  inline
                />
                <TextInput
                  id="youtube"
                  label="YouTube"
                  placeholder="Enter YouTube URL"
                  type="text"
                  value={values.youtube}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.youtube && errors.youtube}
                  inline
                />
                <TextInput
                  id="logo"
                  label="Logo"
                  type="text"
                  value={values.logo}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  inline
                />
                <TextInput
                  id="dates_and_rates"
                  label="Dates and Rates"
                  type="textarea"
                  value={values.dates_and_rates}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  inline
                />
              </Section>

              <Section>
                <SectionHeader title="Camp Address" />
                <TextInput
                  id="camp_address"
                  label="Address"
                  placeholder="Enter address line one"
                  type="text"
                  value={values.camp_address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  inline
                />
                <TextInput
                  id="camp_address_2"
                  label="Address 2"
                  placeholder="Enter address line two"
                  type="text"
                  value={values.camp_address_2}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  inline
                />
                <TextInput
                  id="camp_city"
                  label="City"
                  placeholder="Enter city"
                  type="text"
                  value={values.camp_city}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.camp_city && errors.camp_city}
                  inline
                />
                <InlineInputWrapper label="State" inline>
                  <select id={"camp_state"} onChange={handleChange}>
                    {states.map((state, index) => (
                      <option
                        key={`camp_state_state_${state.name}`}
                        value={state.name}
                      >
                        {state.name}
                      </option>
                    ))}
                  </select>
                </InlineInputWrapper>
                <TextInput
                  id="camp_zip"
                  label="Zip"
                  placeholder="Enter zip"
                  type="text"
                  value={values.camp_zip}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.camp_zip && errors.camp_zip}
                  inline
                />
                <TextInput
                  id="camp_country"
                  label="Country"
                  placeholder="Enter country"
                  type="text"
                  value={values.camp_country}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.camp_country && errors.camp_country}
                  inline
                />
                <TextInput
                  id="camp_phone"
                  label="Phone"
                  placeholder="Enter phone number"
                  type="text"
                  value={values.camp_phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.camp_phone && errors.camp_phone}
                  inline
                />
                <TextInput
                  id="camp_fax"
                  label="Fax"
                  placeholder="Enter fax number"
                  type="text"
                  value={values.camp_fax}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.camp_fax && errors.camp_fax}
                  inline
                />
              </Section>

              <Section>
                <SectionHeader title="Camp Type Information" />
                <InlineInputWrapper label="Camp type" inline>
                  {types.map(type => (
                    <InlineInput
                      key={`camp_type_${type.value}`}
                      id={type.value}
                      label={type.display}
                      type="checkbox"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  ))}
                </InlineInputWrapper>
                <TextInput
                  id="camp_enrollment"
                  label="Enrollment"
                  placeholder="Enter max number of campers"
                  type="number"
                  value={values.camp_enrollment}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.camp_enrollment && errors.camp_enrollment}
                  inline
                />
                <TextInput
                  id="camp_age_range"
                  label="Age range"
                  placeholder="Enter age range of campers"
                  type="text"
                  value={values.camp_age_range}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.camp_age_range && errors.camp_age_range}
                  inline
                />
                <InlineInputWrapper
                  label="Camp gender"
                  id="camp_gender"
                  error={touched.camp_gender && errors.camp_gender}
                  inline
                  inlineChildren
                >
                  {genders.map(gender => (
                    <InlineInput
                      key={`camp_gender_${gender.value}`}
                      id={`camp_gender_${gender.value}`}
                      type="radio"
                      label={gender.display}
                      name="camp_gender"
                      value={gender.value}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  ))}
                </InlineInputWrapper>
                <InlineInputWrapper
                  label="Accreditation"
                  id="camp_accreditation"
                  error={
                    touched.camp_accreditation && errors.camp_accreditation
                  }
                  inline
                  inlineChildren
                >
                  <InlineInput
                    id="camp_accreditation_yes"
                    type="radio"
                    label="Yes"
                    name="accreditation"
                    value={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.camp_accreditation_yes &&
                      errors.camp_accreditation_yes
                    }
                  />
                  <InlineInput
                    id="camp_accreditation_no"
                    type="radio"
                    label="No"
                    name="accreditation"
                    value={false}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.camp_accreditation_no &&
                      errors.camp_accreditation_no
                    }
                  />
                </InlineInputWrapper>
              </Section>

              <Section>
                <SectionHeader title="Camp Description" />
                <TextInput
                  id="description_brief_campers"
                  label="Brief description"
                  type="textarea"
                  value={values.description_brief_campers}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    touched.description_brief_campers &&
                    errors.description_brief_campers
                  }
                  inline
                />
                <TextInput
                  id="description_full_campers"
                  label="Full description"
                  type="textarea"
                  value={values.description_full_campers}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    touched.description_full_campers &&
                    errors.description_full_campers
                  }
                  inline
                />
              </Section>

              <SubmitButton type="submit" isSubmitting={isSubmitting}>
                Submit
              </SubmitButton>
            </InputFields>
            <SelectFields>
              <Section>
                <SectionHeader title="Camp Specialties" />

                {this.state.camp_specialties !== null &&
                  this.state.camp_specialties !== undefined &&
                  this.state.camp_specialties.length >= 0 &&
                  this.state.camp_specialties.map(camp_specialty => (
                    <InlineInput
                      key={`camp_specialty_${camp_specialty.id}`}
                      id={`camp_specialty_${camp_specialty.id}`}
                      label={camp_specialty.attributes.name}
                      type="checkbox"
                      onChange={event =>
                        this.pushToValue(
                          event,
                          values.camp_specialty_ids,
                          camp_specialty.id
                        )}
                      onBlur={handleBlur}
                    />
                  ))}
              </Section>

              <Section>
                <SectionHeader title="Camp Expertises" />

                {this.state.camp_expertises !== null &&
                  this.state.camp_expertises !== undefined &&
                  this.state.camp_expertises.length >= 0 &&
                  this.state.camp_expertises.map(camp_expertise => (
                    <InlineInput
                      key={`camp_expertise_${camp_expertise.id}`}
                      id={`camp_expertise_${camp_expertise.id}`}
                      label={camp_expertise.attributes.name}
                      type="checkbox"
                      onChange={event =>
                        this.pushToValue(
                          event,
                          values.camp_expertise_ids,
                          camp_expertise.id
                        )}
                      onBlur={handleBlur}
                    />
                  ))}
              </Section>
            </SelectFields>
          </FormContainer>
        </FormWrapper>
      </Container>
    )
  }
}

const urlMatch = /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi

export const validationSchema = Yup.object().shape({
  name: Yup.string().required("camp name is required"),
  email: Yup.string()
    .required("email is required")
    .email("must be a valid email address"),
  website: Yup.string().matches(urlMatch, {
    message: "must be a valid URL",
    excludeEmptyString: true,
  }),
  facebook: Yup.string().matches(urlMatch, {
    message: "must be a valid URL",
    excludeEmptyString: true,
  }),
  twitter: Yup.string().matches(urlMatch, {
    message: "must be a valid URL",
    excludeEmptyString: true,
  }),
  skype: Yup.string().matches(urlMatch, {
    message: "must be a valid URL",
    excludeEmptyString: true,
  }),
  instagram: Yup.string().matches(urlMatch, {
    message: "must be a valid URL",
    excludeEmptyString: true,
  }),
  youtube: Yup.string().matches(urlMatch, {
    message: "must be a valid URL",
    excludeEmptyString: true,
  }),
  enrollment: Yup.number()
    .typeError("must be a number")
    .integer("must be a whole number")
    .positive("must be a positive number"),
})

let initialCampValues = {
  name: "",
  session_start_date_month: "",
  session_start_date_day: "",
  session_start_date_year: "",
  session_end_date_month: "",
  session_end_date_day: "",
  session_end_date_year: "",
  website: "",
  email: "",
  facebook: "",
  twitter: "",
  skype: "",
  instagram: "",
  youtube: "",
  dates_and_rates: "",
  camp_address: "",
  camp_address_2: "",
  camp_city: "",
  camp_state: "",
  camp_zip: "",
  camp_country: "",
  camp_phone: "",
  camp_fax: "",
  camp_enrollment: "",
  camp_age_range: "",
  camp_gender: "coed",
  camp_accreditation: "",
  description_brief_campers: "",
  description_full_campers: "",
  card_number: "",
  security_code: "",
  card_expiration: "",
  camp_specialty_ids: [],
  camp_expertise_ids: [],
}

types.forEach(type => (initialCampValues[type.value] = false))

const CampNewFormik = Formik({
  mapPropsToValues: () => initialCampValues,
  validationSchema,
  handleSubmit: (values, bag) => bag.props.handleSubmit(values, bag),
  displayName: "CampNewForm",
})

export default CampNewFormik(CampNewForm)

const Container = glamorous.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  background: "white",
  padding: "2rem",
  width: "100%",
})

const FormTitle = glamorous.h1({
  color: style.colors.green,
  fontSize: "2rem",
  fontWeight: 400,
  marginBottom: "3rem",
})

const FormContainer = glamorous.div({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  [style.size.mobile]: {
    flexDirection: "column",
  },
})

const InputFields = glamorous.div({
  width: "57%",
  marginRight: "3%",
  [style.size.mobile]: {
    width: "100%",
    marginRight: 0,
  },
})

const SelectFields = glamorous.div({
  width: "37%",
  marginLeft: "3%",
  [style.size.mobile]: {
    width: "100%",
    marginLeft: 0,
    marginTop: "4rem",
  },
})

const Section = glamorous.div({
  marginBottom: "4rem",
})



// WEBPACK FOOTER //
// ./src/components/Form/CampNewForm/index.js